import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { cashinForMng } from 'services/loans'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSetCashinMng() {
    const finishFlow = useFinishFlow(FLOWS.deposit)
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFuckingPayload) => {
            return cashinForMng(payload)
        },
        onSuccess: (data, variables) => {
            posthog.capture('payment_recorded', { flow_type: 'manager_record', amount: (variables as any)?.amount })
            toast.success('واریز با موفقیت ثبت شد')
            // back to the fund the deposit was registered in, the way Android
            // does (MoneypoolPayActivity:425) — the fund list loses the context
            // the manager was working in. Leaving the flow rather than pushing
            // the fund on top of it: back from there used to reopen this
            // receipt, with «پرداخت تنها ثبت شود» still live on it.
            const moneyPoolId = (variables as any)?.moneyPool
            finishFlow(moneyPoolId ? `/fund/${moneyPoolId}` : '/funds')
        },
        onError: (error: any) => {
            posthog.capture('payment_record_failed', { flow_type: 'manager_record' })
            toast.error(
                error?.response?.status === 403
                    ? 'فقط مدیران صندوق می‌توانند پرداخت ثبتی ثبت کنند'
                    : 'خطایی رخ داده'
            )
        },
    })

    return { isLoading, mutate }
}
